import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { getLoRaDevices, sendCalibration } from '../api';
import type { CalibrationRequest } from '../types';

export const loraCalibrationKeys = {
  all: ['lora-calibration'] as const,
  devices: () => [...loraCalibrationKeys.all, 'devices'] as const,
};

export function useLoRaDevices() {
  return useQuery({
    queryKey: loraCalibrationKeys.devices(),
    queryFn: getLoRaDevices,
    staleTime: 30_000,
  });
}

export function useSendCalibration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (req: CalibrationRequest) => sendCalibration(req),
    onSuccess: (data) => {
      if (data.success) {
        toast.success(`Calibration sent (payload: ${data.payload})`);
      } else {
        toast.error(`Calibration failed: ${data.error}`);
      }
      queryClient.invalidateQueries({ queryKey: loraCalibrationKeys.devices() });
    },
    onError: (error: Error) => {
      toast.error(`Calibration error: ${error.message}`);
    },
  });
}
